import { Box, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Menu from "../../centralOms/common/menu";
import Container from "@mui/material/Container";
import { download, fetchOrders } from "../../centralOms/common/apiCalls";
import { toast } from "react-toast";
import { dateFilters } from "../../centralOms/common/constants";
import { TableStructure } from "../tableStructure";
import { EVENTS } from "../../centralOms/events_constant";

export const NotAttended = ({ fetchData, setFetchData, searchAppointment }) => {
  const [page, setPage] = useState(1);
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const dateFilterObject = JSON.parse(sessionStorage.getItem("dateFilterObject"));
  const dateFilterName = dateFilterObject?.name ? dateFilterObject.name : "Previous 7 Days";
  const selectedDateFilter = dateFilters.find((elem) => elem.name === dateFilterName);
  const startDate = dateFilterObject?.startDate ? dateFilterObject.startDate : selectedDateFilter.startDate;
  const endDate = dateFilterObject?.endDate ? dateFilterObject.endDate : selectedDateFilter.endDate;
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortLabel, setSortLabel] = useState("");

  const fetchOrderData = async () => {
    try {
      setLoading(true);
      setOrders([]);
      let response = await fetchOrders(["LABS"], ["NOT_ATTENDED"], [], startDate, endDate, page, searchAppointment, false, sortLabel, sortDirection);
      setOrders(response.data.requestDetails);
      setTotalRows(response.data.totalRecords ? response.data.totalRecords : 0);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const tokenExpired = localStorage.getItem("tokenExpired");
      if (tokenExpired === "true") {
        localStorage.clear();
        history.push("/login");
      } else {
        toast.error("Failed to fetch data");
      }
    }
  };

  const exportOrderData = async () => {
    try {
      setExportLoading(true);
      let response = await fetchOrders(["LABS"], ["NOT_ATTENDED"], [], startDate, endDate, page, searchAppointment, true);
      download(response, "AppointmentData");
      setExportLoading(false);
    } catch (err) {
      setExportLoading(false);
      const tokenExpired = localStorage.getItem("tokenExpired");
      if (tokenExpired === "true") {
        localStorage.clear();
        history.push("/login");
      } else {
        toast.error("Failed to export data");
      }
    }
  };

  useEffect(() => {
    fetchOrderData();
  }, [fetchData]);

  return (
    <Container maxWidth="xlg" className="pt-3">
      <Box className="pb-4" sx={{ width: "100%" }}>
        <Paper className="appointment-container" sx={{ width: "100%", mb: 2 }}>
          <Menu tab={9} history={history} totalRows={totalRows} service={"LABS"}></Menu>
          <TableStructure
            tabName={EVENTS.TAB_NAME__NOT_ATTENDED}
            orders={orders}
            totalRows={totalRows}
            page={page}
            setPage={setPage}
            loading={loading}
            exportLoading={exportLoading}
            fetchData={fetchData}
            setFetchData={setFetchData}
            exportOrderData={exportOrderData}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            setSortLabel={setSortLabel}
          ></TableStructure>
        </Paper>
      </Box>
    </Container>
  );
};
